import { useCountUp } from '../hooks';

interface CountUpProps {
  to: number;
  trigger: boolean;
  duration?: number;
  decimals?: number;
  prefix?: string;
  suffix?: string;
  className?: string;
}

export function CountUp({ to, trigger, duration, decimals, prefix, suffix, className }: CountUpProps) {
  const value = useCountUp(to, trigger, { duration, decimals, prefix, suffix });
  return <span className={className}>{value}</span>;
}
